import * as topic_permissions from "./topic_permissions.ts";

// Cache only viewer-filtered HTML, never the manager's source or permission lists.
type DescriptionEntry = {value?: string | null; retry_after?: number};
const descriptions = new Map<string, DescriptionEntry>();
let generation = 0;

export function invalidate(): void {
    generation += 1;
    descriptions.clear();
}

export function invalidate_streams(stream_ids: Set<number>): void {
    for (const key of descriptions.keys()) {
        const [stream_id] = JSON.parse(key) as [number, string];
        if (stream_ids.has(stream_id)) {
            descriptions.delete(key);
        }
    }
}

export function get(
    stream_id: number, topic: string, on_ready: () => void,
): string | null | undefined {
    const key = topic_permissions.capability_key(stream_id, topic);
    const cached = descriptions.get(key);
    if (cached && (cached.retry_after === undefined || Date.now() < cached.retry_after)) {
        return cached.value;
    }
    const entry: DescriptionEntry = {};
    descriptions.set(key, entry);
    const request_generation = generation;
    topic_permissions.fetch_topic_permissions(stream_id, topic, (data) => {
        if (request_generation !== generation || descriptions.get(key) !== entry) {
            return;
        }
        entry.value = data.rendered_description === null ? null
            : typeof data.rendered_description === "string" ? data.rendered_description : "";
        on_ready();
    }, () => {
        if (request_generation !== generation || descriptions.get(key) !== entry) {
            return;
        }
        // A failed request must not expose a channel description as an override.
        entry.value = "";
        entry.retry_after = Date.now() + 5000;
        on_ready();
    });
    return entry.value;
}
